import Logo from "../../../assets/images/Dhell_Logo_White.png";
import { Link } from "react-router-dom";
import { LINKS_DATA, SOCIAL_MEDIA_DATA } from "../../../utils/constants";

import { FaInstagram, FaTwitter, FaFacebookF } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className='flex min-h-[28.875rem] flex-col items-center justify-between bg-primary2'>
      <div className='pt-[4rem] w-full px-10'>
        <div className='flex flex-col items-center gap-x-[15.5rem] gap-y-8 lg:flex-row'>

          <div className='self-center laptopS:self-start'>
            {/* Logo */}
            <div className='w-full h-full max-w-[11.81rem] max-h-[3rem] m-auto laptopS:m-0'>
              <Link path={"/"}>
                <img src={Logo} />
              </Link>
            </div>
          </div>

          {/* Links */}
          <div dir="rtl" className='flex w-full flex-col mt-6 laptopS:mt-0 items-center justify-between tabletM:gap-y-8 tabletM:flex-row tabletM:items-start'>
            {/* Pages */}
            <div className='w-[19rem] tabletM:w-[16rem] tabletM:me-6'>
              <h2 className='text-custom-20 font-custom-700 text-primary4'>
                الصفحات
              </h2>
              <ul className='mt-[1.5rem] mb-4 flex w-full flex-col gap-4 tabletM:mt-6'>
                {LINKS_DATA?.map((item, index) => (
                  <li className='text-custom-18 font-custom-400 text-primary4'>
                    <Link
                      className={
                        'transition-all duration-300 hover:text-primary hover:font-custom-800'
                      }
                      to={item?.path}
                      key={item?.nameAr + index + 'Footer'}
                    >
                      {item?.nameAr}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            {/* End Pages */}

            {/* Contact Us */}
            <div className='w-[19rem] tabletM:w-[16rem] tabletM:me-6'>
              <h2 className='text-custom-20 font-custom-700 text-primary4'>
                تواصل معنا
              </h2>

              <div className='my-[1.5rem] flex w-full flex-col gap-4 tabletM:mt-6'>
                <div className='text-custom-18 text-primary4'>
                  <h2 className='font-custom-700 mb-2'>بريد الكتروني</h2>
                  <p className='font-custom-400'>Dhell.center@gmail.com</p>
                </div>

                <div className='text-custom-18 text-primary4'>
                  <h2 className='font-custom-700 mb-2'>هاتف</h2>
                  <p className='font-custom-400'>0559833211</p>
                </div>
              </div>
            </div>

            {/* Address */}
            <div className='w-[19rem] tabletM:w-[16rem] tabletM:me-6 text-primary4'>
              <h2 className='text-custom-20 font-custom-700 '>موقعنا</h2>
              <p className='font-custom-400'>
                السعودية / الرياض - حي الملقا - شارع انس بن مالك
              </p>
            </div>

            {/* End Contact Us */}
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className='h-full w-full mt-4 laptopS:mt-0 '>
        {/*  Social Media */}
        <ul className='flex gap-[0.9375rem] mx-10 mb-6'>
          <a target='_blank' href={SOCIAL_MEDIA_DATA?.instagram?.link}>
            <li className='p-2 group bg-primary4 rounded-full'>
              <FaInstagram className='w-5 h-5 fill-primary2 group-hover:fill-primary transition-all duration-500' />
            </li>
          </a>
          <a target='_blank' href={SOCIAL_MEDIA_DATA?.facebook?.link}>
            <li className='p-2 group bg-primary4 rounded-full'>
              <FaFacebookF className='w-5 h-5 fill-primary2 group-hover:fill-primary transition-all duration-500' />
            </li>
          </a>
          <a target='_blank' href={SOCIAL_MEDIA_DATA?.twitter?.link}>
            <li className='p-2 group bg-primary4 rounded-full'>
              <FaTwitter className='w-5 h-5 fill-primary2 group-hover:fill-primary transition-all duration-500' />
            </li>
          </a>
        </ul>
        <hr className='border-2 mx-10' />
        <div className='my-[1.5rem] flex content-end justify-center gap-2'>
          <p className='text-custom-18 font-custom-400 text-primary4'>
            جميع الحقوق محفوظة لدى © ظل
          </p>
        </div>
      </div>
    </footer>
  );
}